<app-title-bar rootBreadCrumbs="['i18n.core.navigation.reports']" titleText="i18n.domain.reports.user-extract.title"></app-title-bar>
<div class="row">
  <app-user-extract-form class="col"
                          [form]="filterForm"
                          (searchDTOChanged)="searchReports()"></app-user-extract-form>
</div>
@if(filterForm.controls.startDate.value && filterForm.controls.endDate.value) {
  <ejs-grid #grid
            class="grid-with-footer"
            width="100%"
            rowHeight="38"
            [allowPaging]="true"
            [pageSettings]="pageSettings"
            [dataSource]="data">
    <e-columns>
      <e-column field="entryDate"
                headerText="{{'i18n.domain.reports.user-extract.grid.entryDate' | translate}}"
                type="date"
                format="dd.MM.yyyy HH:mm:ss"
                clipMode="EllipsisWithTooltip">
      </e-column>
      <e-column field="exitDate"
                headerText="{{'i18n.domain.reports.user-extract.grid.exitDate' | translate}}"
                type="date"
                format="dd.MM.yyyy HH:mm:ss"
                clipMode="EllipsisWithTooltip">
      </e-column>
      <e-column field="durationInMinutes"
                headerText="{{'i18n.domain.reports.user-extract.grid.durationInMinutes' | translate}}"
                clipMode="EllipsisWithTooltip">
        <ng-template #template
                     let-data>
          {{formatTime(data.durationInMinutes) + 'h'}}
        </ng-template>
      </e-column>
      <e-column field="zoneName"
                headerText="{{'i18n.domain.reports.user-extract.grid.zone' | translate}}"
                clipMode="EllipsisWithTooltip">
      </e-column>
      <e-column field="clientName"
                headerText="{{'i18n.domain.reports.user-extract.grid.client' | translate}}"
                clipMode="EllipsisWithTooltip">
      </e-column>
      <e-column field="amount"
                headerText="{{'i18n.domain.reports.user-extract.grid.amount' | translate}}"
                clipMode="EllipsisWithTooltip">
        <ng-template #template
                     let-data>
          {{data.amount | number : '1.2-2'}}
        </ng-template>
      </e-column>
      <e-column field="currency"
                headerText="{{'i18n.domain.reports.user-extract.grid.currency' | translate}}"
                clipMode="EllipsisWithTooltip">
        <ng-template #template
                     let-data>
          {{formatCurrency(data.currency) | translate}}
        </ng-template>
      </e-column>
    </e-columns>
  </ejs-grid>

  <app-reports-footer (saveClicked)="saveReport($event)">
    <div left class="d-flex flex-column align-items-end">
    @if(summaryData) {
      {{'i18n.domain.reports.user-extract.totalParkings' | translate}}: {{summaryData.totalNumberOfParkings}}
    }
    </div>
    <div right class="amount-display w-100">
    @if(summaryData) {
      <div class="mt-lg-0 mt-2">
      @for(summary of summaryData.totalAmounts; track summary) {
        <div class="row">
          <div class="col-lg-9 col-6 d-flex justify-content-lg-end align-items-end">{{'i18n.domain.reports.user-extract.totalAmount' | translate:{currency: Currency[summary.currency]} }}:</div>
          <div class="col-lg-3 col-6 d-flex justify-content-end align-items-end">{{summary.totalPrice| number : '1.2-2'}} {{formatCurrency(summary.currency) | translate}}</div>
        </div>
      }
      </div>
    }
    </div>
  </app-reports-footer>
}

